import { Routes, Route } from 'react-router-dom'
import AboutPage from '../pages/about/AboutPage'
import ContactPage from '../pages/contact/ContactPage'
import HomePage from '../pages/home/Home'
import Layout from '../pages/layout/Layout'
import ProjectsPage from '../pages/projects/ProjectsPage'
import SkillsPage from '../pages/skills/SkillsPage'
import WorkExperiencePage from '../pages/work_experience/WorkExperiencePage'

const AppRouter = () => {
	return (
		<Routes>
			<Route element={<Layout />} >
				<Route path="/" element={<HomePage />} />
				<Route path="about" element={<AboutPage />} />
				<Route path="projects" element={<ProjectsPage />} />
				<Route path="skills" element={<SkillsPage />} />
				<Route path="contact" element={<ContactPage />} />
				<Route path="/work-experience" element={<WorkExperiencePage />} />
			</Route>
		</Routes>
	)
}

export default AppRouter